import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "w-full flex justify-center"
}
const _hoisted_3 = { class: "text-center text-lg shadow-none w-full min-w-fit mt-[-1rem] h-fit font-semibold text-black-600" }
const _hoisted_4 = { class: "grid xl:grid-cols-3 grid-cols-2 h-max gap-x-4 text-[#243045]" }
const _hoisted_5 = { class: "xl:col-span-1 col-span-2 h-full mt-2" }
const _hoisted_6 = { class: "m-4 border-2 border-[#e5e7eb] rounded-lg border-solid p-2 pb-0.5" }
const _hoisted_7 = {
  key: 0,
  class: "w-full flex justify-center"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "matchId",
  class: "font-bold block mb-2 text-center min-w-max px-2 w-1/3"
}, " Match Id: ", -1)
const _hoisted_9 = { class: "flex 2xl:flex-row xl:flex-col md:flex-row flex-col w-full items-center" }
const _hoisted_10 = { class: "flex w-full" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold block mb-2 w-1/3 text-center min-w-max px-2" }, "Result: ", -1)
const _hoisted_12 = { class: "flex w-full mb-1.5" }
const _hoisted_13 = { class: "card flex wrap-none justify-center m-auto w-2/3 max-w-min" }
const _hoisted_14 = { class: "m-4 border-2 border-[#e5e7eb] rounded-lg border-solid p-2 pb-0.5" }
const _hoisted_15 = { class: "flex mb-4" }
const _hoisted_16 = { class: "font-bold block mb-2 w-1/3 text-center min-w-max px-2" }
const _hoisted_17 = {
  key: 0,
  class: "text-red-500 text-xs pl-1 flex w-full justify-center font-normal"
}
const _hoisted_18 = { class: "flex mb-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold block mb-2 w-1/3 text-center min-w-max px-2" }, "Finish Date: ", -1)
const _hoisted_20 = { class: "flex" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold block mb-2 w-1/3 text-center min-w-max px-2" }, "Match Days: ", -1)
const _hoisted_22 = { class: "m-4 border-2 border-[#e5e7eb] rounded-lg border-solid p-2 pb-0.5" }
const _hoisted_23 = { class: "flex mb-4" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  for: "series",
  class: "font-bold block mb-2 w-1/3 text-center min-w-max px-2"
}, "Series: ", -1)
const _hoisted_25 = { class: "flex mb-4" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  for: "season",
  class: "font-bold block mb-2 w-1/3 text-center min-w-max px-2"
}, "Season: ", -1)
const _hoisted_27 = { class: "flex" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", {
  for: "startType",
  class: "font-bold block mb-2 w-1/3 text-center min-w-max px-2"
}, "Match Type: ", -1)
const _hoisted_29 = { class: "m-4 border-2 border-[#e5e7eb] rounded-lg border-solid p-2 pb-0.5 justify-center items-center flex" }
const _hoisted_30 = {
  for: "season",
  class: "font-bold block w-1/3 text-center min-w-max px-2 h-full self-center mb-2"
}
const _hoisted_31 = {
  key: 0,
  class: "text-red-500 text-xs pl-1 flex w-full justify-center font-normal"
}
const _hoisted_32 = { class: "flex flex-col w-2/3 items-end mb-2" }
const _hoisted_33 = { class: "m-4 mb-0 border-2 border-[#e5e7eb] rounded-lg border-solid p-0.5 justify-center items-center" }
const _hoisted_34 = { class: "flex mb-2 mt-1" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold block w-1/3 text-center content-center min-w-max px-2" }, "Toss Winner: ", -1)
const _hoisted_36 = { class: "flex mb-1" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold block w-1/3 text-center content-center min-w-max px-2" }, " Toss Decision: ", -1)
const _hoisted_38 = { class: "card flex wrap-none justify-center m-auto" }
const _hoisted_39 = { class: "col-span-2 h-full" }
const _hoisted_40 = { class: "grid grid-cols-2" }
const _hoisted_41 = { class: "col-span-1 h-fit border-r mt-4 px-2" }
const _hoisted_42 = { class: "text-center w-full min-w-fit h-6 min-h-min relative" }
const _hoisted_43 = {
  key: 0,
  class: "text-red-500 text-xs pl-1 flex w-full justify-center absolute top-[-17px] font-normal"
}
const _hoisted_44 = { class: "flex items-center md:mt-0 mt-1 w-1/3 justify-center" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", {
  for: "homeTeam",
  class: "font-bold block pb-0.5 w-1/3 pr-2 text-center ml-2 min-w-max"
}, "Home Team", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Team Squad", -1)
const _hoisted_47 = { class: "font-bold" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { class: "flex flex-wrap p-0.5 border-b border-solid align-items-center gap-1 players" }
const _hoisted_50 = { class: "font-semibold text-sm" }
const _hoisted_51 = { class: "flex mb-4" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", {
  for: "dayNight",
  class: "font-bold block mb-2 w-1/3 text-center ml-2 min-w-max"
}, "Captain ", -1)
const _hoisted_53 = { class: "flex mb-4" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", {
  for: "vice",
  class: "font-bold block mb-2 w-1/3 text-center ml-2 min-w-max"
}, "Vice-Captain ", -1)
const _hoisted_55 = { class: "flex mb-4" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", {
  for: "dayNight",
  class: "font-bold block mb-2 w-1/3 text-center ml-2 min-w-max"
}, "Wicket Keeper ", -1)
const _hoisted_57 = { class: "col-span-1 mt-4 px-2" }
const _hoisted_58 = { class: "text-center w-full min-w-fit h-6 min-h-min relative" }
const _hoisted_59 = {
  key: 0,
  class: "text-red-500 text-xs pl-1 flex w-full justify-center absolute top-[-17px] font-normal"
}
const _hoisted_60 = { class: "flex items-center md:mt-0 mt-1 w-1/3 justify-center" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", {
  for: "homeTeam",
  class: "font-bold block pb-0.5 w-1/3 pr-2 text-center ml-2 min-w-max"
}, "Home Team", -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Team Squad", -1)
const _hoisted_63 = { class: "font-bold" }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { class: "flex flex-wrap p-0.5 border-b border-solid align-items-center gap-1" }
const _hoisted_66 = { class: "font-semibold text-sm players" }
const _hoisted_67 = { class: "flex mb-4" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", {
  for: "captain",
  class: "font-bold block mb-2 w-1/3 text-center ml-2 min-w-max"
}, "Captain ", -1)
const _hoisted_69 = { class: "flex mb-4" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", {
  for: "vice",
  class: "font-bold block mb-2 w-1/3 text-center ml-2 min-w-max"
}, "Vice-Captain ", -1)
const _hoisted_71 = { class: "flex mb-4" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("label", {
  for: "keeper",
  class: "font-bold block mb-2 w-1/3 text-center ml-2 min-w-max"
}, "Wicket Keeper ", -1)
const _hoisted_73 = { class: "col-span-2 m-4 border-2 border-[#e5e7eb] rounded-lg border-solid p-2 pb-0.5" }
const _hoisted_74 = { class: "flex flex-wrap boundary" }
const _hoisted_75 = { class: "w-1/2 flex justify-around p-0.5 pb-2" }
const _hoisted_76 = { class: "font-bold text-center block min-w-max w-28" }
const _hoisted_77 = {
  key: 0,
  class: "text-red-500 text-xs pl-1 flex w-full justify-center font-normal"
}
const _hoisted_78 = { class: "w-1/2 flex justify-around p-0.5 pb-2" }
const _hoisted_79 = { class: "font-bold text-center block min-w-max w-28" }
const _hoisted_80 = {
  key: 0,
  class: "text-red-500 text-xs pl-1 flex w-full justify-center font-normal"
}
const _hoisted_81 = { class: "w-1/2 flex justify-around p-0.5 pb-2" }
const _hoisted_82 = { class: "font-bold text-center block min-w-max w-28" }
const _hoisted_83 = {
  key: 0,
  class: "text-red-500 text-xs pl-1 flex w-full justify-center font-normal"
}
const _hoisted_84 = { class: "w-1/2 flex justify-around p-0.5 pb-2" }
const _hoisted_85 = { class: "font-bold text-center block min-w-max w-28" }
const _hoisted_86 = {
  key: 0,
  class: "text-red-500 text-xs pl-1 flex w-full justify-center font-normal"
}
const _hoisted_87 = {
  key: 1,
  class: "w-full flex justify-end"
}
const _hoisted_88 = ["disabled"]
const _hoisted_89 = {
  key: 2,
  class: "w-full flex justify-end"
}
const _hoisted_90 = {
  key: 1,
  class: "w-full flex justify-center my-8"
}

import { Ref, ref, onMounted } from 'vue'
import { useApiStore } from "../store/api/api";
import { usePlayApiStore } from "../store/api/playApi";
import { useRealtimeApiStore } from "../store/api/realtimeApi";
import { useConfirm } from "primevue/useconfirm";

import InputText from 'primevue/inputtext';
// import InputNumber from 'primevue/inputnumber';
import Calendar from 'primevue/calendar';
import Dropdown from 'primevue/dropdown';
import Checkbox from 'primevue/checkbox';
import PickList from 'primevue/picklist';
import SelectButton from 'primevue/selectbutton';
import MultiSelect from 'primevue/multiselect';
import ProgressSpinner from 'primevue/progressspinner';
import { GenderEnum, MatchTypeEnum, ResultEnum, SeasonEnum, PlayerCard, TossDecisionEnum, Match, CountryEnum, Coach, Player, MatchVenue } from '@/models/vscoreModels'

// const api = useApiStore();
// const playApi = usePlayApiStore()

export default /*#__PURE__*/_defineComponent({
  __name: 'MatchManager',
  props: ['teams', 'venues', 'selectedMatch'],
  emits: ['changeMatchEditState', 'exitMatchView', 'save'],
  setup(__props, { emit: __emit }) {

const api = useRealtimeApiStore()
const confirm = useConfirm();
const props = __props
const emit = __emit

const state = ref({
    isEditMode: false,
    isLoading: true,
    isMatchNew: Object.keys(props.selectedMatch).length == 0,
    isValid: true,
})


const genderOptions = ref(Object.values(GenderEnum).filter((item) => { return isNaN(Number(item)) }));

// const series: Ref<Series[]> = ref([]);
// const matchRules = ref(['50 Over', '2020', 'Test']);
const matchType = ref(Object.values(MatchTypeEnum).filter((item) => { return isNaN(Number(item)) }));
const result = ref(Object.values(ResultEnum).filter((item) => { return isNaN(Number(item)) }));
// const dayNight = ref(['Day', 'Day / Night', 'Night']);
const season = ref(Object.values(SeasonEnum).filter((item) => { return isNaN(Number(item)) }))
const ground:Ref<MatchVenue[]> = ref(props.venues);
const teams = ref(props.teams);

const playersTeamOne: Ref<Player[][]> = ref([[], []])
const playersTeamTwo: Ref<Player[][]> = ref([[], []])

const tossDecisionOptions = ref(Object.values(TossDecisionEnum).filter((item) => { return isNaN(Number(item)) }));

const umpires = ref()

const teamOneCaptain: Ref<Player> = ref({} as Player)
const teamTwoCaptain: Ref<Player> = ref({} as Player)
const teamOneViceCaptain: Ref<Player> = ref({} as Player)
const teamTwoViceCaptain: Ref<Player> = ref({} as Player)
const teamOneKeeper: Ref<Player> = ref({} as Player)
const teamTwoKeeper: Ref<Player> = ref({} as Player)

const emptyMatch: Match = {
    id: '',
    startDate: '',
    matchType: MatchTypeEnum.Test,
    gender: GenderEnum.Male,
    tossDecision: undefined,
    team1: {
        team: {
            id: '',
            name: '',
        },
        players: [],
        coach: <Coach>{},
        homeTeam: false
    },
    team2: {
        team: {
            id: '',
            name: '',
        },
        players: [],
        coach: <Coach>{},
        homeTeam: false
    },
    season: SeasonEnum._202324,
    series: {
        name: '',
    },
    venue: {
        id: '',
        name: '',
        city: '',
        country: CountryEnum.AFG,
        capacity: 0,
    },
    umpires: {
        matchReferee: {
            id: '',
            firstName: '',
            lastName: '',
            name: '',
            gender: GenderEnum.Male,
        },
        matchUmpires: [],
        tvUmpire: {
            id: '',
            firstName: '',
            lastName: '',
            name: '',
            gender: GenderEnum.Male,
        },
        reserveUmpire: {
            id: '',
            firstName: '',
            lastName: '',
            name: '',
            gender: GenderEnum.Male,
        }
    },
    sessions: [],
    result: ResultEnum.Scheduled
}

const match = ref(emptyMatch)

const matchName = ref('')


const tossWinnerOptions = ref([match.value.team1.team, match.value.team2.team]);


onMounted(async () => {
    populate()
    await api.getAllUmpires().then((value) => {
        umpires.value = JSON.parse(value.data).data;
    })
    if (ground.value.length == 0) {
        await api.getAllVenues().then((value) => {
            ground.value = JSON.parse(value.data).data;
        })
    }
    if (teams.value.length == 0) {
        await api.getAllTeams().then((value) => {
            teams.value = JSON.parse(value.data).data;
        })
    }
})

async function populate() {
    state.value.isLoading = true
    if (!state.value.isMatchNew) {
        matchName.value = props.selectedMatch.name
        match.value = JSON.parse(JSON.stringify(props.selectedMatch))
        // match.value.startDate = new Date(match.value.startDate)
        delete match.value.name

        getPlayersTeamOne()
        getPlayersTeamTwo()

        match.value.team1.players.forEach((playerCard: PlayerCard) => {
            playersTeamOne.value[1].push(playerCard.player)
            if (playerCard.isCaptain) teamOneCaptain.value = playerCard.player
            if (playerCard.isViceCaptain) teamOneViceCaptain.value = playerCard.player
            if (playerCard.isWicketkeeper) teamOneKeeper.value = playerCard.player
        })

        match.value.team2.players.forEach((playerCard: PlayerCard) => {
            playersTeamTwo.value[1].push(playerCard.player)
            if (playerCard.isCaptain) teamTwoCaptain.value = playerCard.player
            if (playerCard.isViceCaptain) teamTwoViceCaptain.value = playerCard.player
            if (playerCard.isWicketkeeper) teamTwoKeeper.value = playerCard.player
        })

        if (match.value.series == undefined) match.value["series"] = { name: "" }

    } else {
        // match.value = emptyMatch
        state.value.isEditMode = true
    }

    tossWinnerOptions.value = [match.value.team1.team, match.value.team2.team];

    // TODO
    // await api.fetchSeriesList().then((value) => {
    //     JSON.parse(value.data).data.forEach((element: any) => {
    //         series.value.push({ name: element["matches.series"] })
    //     });
    // })
    state.value.isLoading = false
}

const confirmSave = () => {
    validate()
    if (state.value.isValid) {
        confirm.require({
            message: 'Confirm to save',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            rejectLabel: 'Cancel',
            acceptLabel: 'Save',
            accept: () => {
                state.value.isEditMode = false;
                emit('changeMatchEditState', false)
                save()
            }
        });
    }
};

const confirmCancel = () => {
    confirm.require({
        message: 'Are you sure you want to cancel? Your changes will be lost',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        rejectLabel: 'No',
        acceptLabel: 'Yes',
        accept: () => {
            state.value.isEditMode = false;
            emit('changeMatchEditState', false)
            if (Object.keys(props.selectedMatch).length !== 0) {
                populate()
            } else {
                emit('exitMatchView')
            }
        }
    });
};

function validate() {
    state.value.isValid = true
    if (!match.value.startDate) state.value.isValid = false
    if (!match.value.venue.id) state.value.isValid = false
    if (!match.value.team1.team.id) state.value.isValid = false
    if (!match.value.team2.team.id) state.value.isValid = false
    if (!match.value.umpires.matchReferee.id) state.value.isValid = false
    if (match.value.umpires.matchUmpires.length == 0) state.value.isValid = false
    if (!match.value.umpires.tvUmpire.id) state.value.isValid = false
    if (!match.value.umpires.reserveUmpire.id) state.value.isValid = false
}

async function getPlayersTeamOne() {
    playersTeamOne.value = [[], []]
    let teamSquad: Player[] = [];
    await api.getSquadByTeamId(match.value.team1.team.id).then((value) => {
        teamSquad = JSON.parse(value.data).data;
        teamSquad.forEach((player: Player) => {
            let playerAlreadyPlaying = false
            match.value.team1.players?.forEach((playerCard: PlayerCard) => {
                if (playerCard.player.id == player.id) {
                    playerAlreadyPlaying = true
                }
            })
            if (!playerAlreadyPlaying) {
                playersTeamOne.value[0].push(player)
            }
        })
    })


}

async function getPlayersTeamTwo() {
    playersTeamTwo.value = [[], []]
    let teamSquad: Player[] = [];
    await api.getSquadByTeamId(match.value.team2.team.id).then((value) => {
        teamSquad = JSON.parse(value.data).data;
        teamSquad.forEach((player: Player) => {
            let playerAlreadyPlaying = false
            match.value.team2.players?.forEach((playerCard: PlayerCard) => {
                if (playerCard.player.id == player.id) {
                    playerAlreadyPlaying = true
                }
            })
            if (!playerAlreadyPlaying) {
                playersTeamTwo.value[0].push(player)
            }
        })
    })


}

function teamSelected(isTeamOne: boolean) {
    if (isTeamOne) {
        match.value.team1.coach = <Coach>{}
        match.value.team1.homeTeam = false
        match.value.team1.players = []
        getPlayersTeamOne()
    } else {
        match.value.team2.coach = <Coach>{}
        match.value.team2.homeTeam = false
        match.value.team2.players = []
        getPlayersTeamTwo()
    }

    tossWinnerOptions.value = [match.value.team1.team, match.value.team2.team];

}

function updateName() {
    if (match.value.startDate !== '' && match.value.team1.team.name !== '' && match.value.team2.team.name !== '' && match.value.venue.name !== '') {
        matchName.value = match.value.team1.team.name + " vs " + match.value.team2.team.name + " at " + match.value.venue.name + " on " + (new Date(match.value.startDate)).toUTCString()
    }
}

async function save() {
    // TODO
    // Are my substitutes those not picked from the squad - or should i have a substitutes dropdown list?
    // Add selected players to match team
    if (state.value.isMatchNew) {
        playersTeamOne.value[1].forEach((player: Player) => {
            let newPlayerCard = {} as PlayerCard;
            newPlayerCard.player = player
            newPlayerCard.isCaptain = teamOneCaptain.value.id == player.id ? true : false
            newPlayerCard.isViceCaptain = teamOneViceCaptain.value.id == player.id ? true : false
            newPlayerCard.isWicketkeeper = teamOneKeeper.value.id == player.id ? true : false
            newPlayerCard.isSubstitute = false
            match.value.team1.players.push(newPlayerCard)
        });
        playersTeamTwo.value[1].forEach((player: Player) => {
            let newPlayerCard = {} as PlayerCard;
            newPlayerCard.player = player
            newPlayerCard.isCaptain = teamTwoCaptain.value.id == player.id ? true : false
            newPlayerCard.isViceCaptain = teamTwoViceCaptain.value.id == player.id ? true : false
            newPlayerCard.isWicketkeeper = teamTwoKeeper.value.id == player.id ? true : false
            newPlayerCard.isSubstitute = false
            match.value.team2.players.push(newPlayerCard)
        });

        // Create new match object to change values into ID's were needed
        const newMatch: Ref<any> = ref(JSON.parse(JSON.stringify(match.value)))

        newMatch.value.team1.players.forEach((playerCard: any) => {
            playerCard["id"] = playerCard.player.id
            delete playerCard.player
        });
        newMatch.value.team2.players.forEach((playerCard: any) => {
            playerCard["id"] = playerCard.player.id
            delete playerCard.player
        });

        delete newMatch.value.venue
        newMatch.value["venueId"] = match.value.venue.id

        delete newMatch.value.umpires.matchReferee
        newMatch.value.umpires["matchRefereeId"] = match.value.umpires.matchReferee.id

        delete newMatch.value.umpires.tvUmpire
        newMatch.value.umpires["tvUmpireId"] = match.value.umpires.tvUmpire.id

        delete newMatch.value.umpires.reserveUmpire
        newMatch.value.umpires["reserveUmpireId"] = match.value.umpires.reserveUmpire.id

        delete newMatch.value.umpires.matchUmpires
        newMatch.value.umpires["matchUmpireIds"] = []
        match.value.umpires.matchUmpires.forEach((umpire: any) => {
            newMatch.value.umpires["matchUmpireIds"].push(umpire.id)
        });

        delete newMatch.value.team1.team
        newMatch.value.team1["teamId"] = match.value.team1.team.id

        delete newMatch.value.team2.team
        newMatch.value.team2["teamId"] = match.value.team2.team.id

        delete newMatch.value.team1.coach
        newMatch.value.team1["coachId"] = "FAKEID"

        delete newMatch.value.team2.coach
        newMatch.value.team2["coachId"] = "FAKEID"


        // let newMatchId;
        // API Call
        // await api.createMatch(newMatch.value).then((response: any) => {
        //     state.value.isMatchNew = false
        //     console.log("location: " + response)
        //     // newMatchId = response.split("/")[1]
        // })
        // match.value.venue = tempVenue
        // newMatchId = "FAKEID"
    } else {
        // TODO - update match
    }
    emit('save')
}


return (_ctx: any,_cache: any) => {
  return (!state.value.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (matchName.value !== '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(matchName.value), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (match.value.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _hoisted_8,
                    _createVNode(_unref(InputText), {
                      modelValue: match.value.id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((match.value.id) = $event)),
                      class: "text-left shadow-none h-6 w-2/3",
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_unref(Dropdown), {
                    modelValue: match.value.result,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((match.value.result) = $event)),
                    options: result.value,
                    placeholder: "",
                    class: "text-center rounded-md border-2 shadow-none w-2/3 min-w-fit h-6",
                    disabled: !state.value.isEditMode
                  }, null, 8, ["modelValue", "options", "disabled"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_unref(SelectButton), {
                      modelValue: match.value.gender,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((match.value.gender) = $event)),
                      options: genderOptions.value,
                      disabled: !state.value.isEditMode,
                      allowEmpty: false,
                      pt: { button: { class: ['py-0 px-1 bg-[#e5e7eb] border rounded-md m-0.5 w-[80px] text-sm'] }, },
                      class: "toss-decision bg-[#e5e7eb] rounded-md"
                    }, null, 8, ["modelValue", "options", "disabled"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, [
                  _createTextVNode("Start Date: "),
                  (!state.value.isValid && !match.value.startDate)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, " Please fill in this field "))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_unref(Calendar), {
                  modelValue: match.value.startDate,
                  "onUpdate:modelValue": [
                    _cache[3] || (_cache[3] = ($event: any) => ((match.value.startDate) = $event)),
                    _cache[4] || (_cache[4] = ($event: any) => (updateName()))
                  ],
                  showTime: "",
                  class: "text-center rounded-md border-2 shadow-none w-2/3 min-w-fit h-6 self-center",
                  showIcon: "",
                  disabled: !state.value.isEditMode
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_unref(Calendar), {
                  modelValue: match.value.finishDate,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((match.value.finishDate) = $event)),
                  class: "text-center rounded-md border-2 shadow-none w-2/3 min-w-fit h-6",
                  showIcon: "",
                  disabled: !state.value.isEditMode
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createVNode(_unref(Calendar), {
                  modelValue: match.value.matchDays,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((match.value.matchDays) = $event)),
                  dataFormat: "yy-mm-dd",
                  class: "text-center rounded-md border-2 shadow-none w-2/3 min-w-fit h-6",
                  showIcon: "",
                  disabled: !state.value.isEditMode,
                  selectionMode: "multiple"
                }, null, 8, ["modelValue", "disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createVNode(_unref(InputText), {
                  modelValue: match.value.series.name,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((match.value.series.name) = $event)),
                  placeholder: "",
                  class: "text-center rounded-md border-2 shadow-none w-2/3 min-w-fit h-6",
                  disabled: !state.value.isEditMode
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createVNode(_unref(Dropdown), {
                  modelValue: match.value.season,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((match.value.season) = $event)),
                  options: season.value,
                  placeholder: "",
                  class: "text-center rounded-md border-2 shadow-none w-2/3 min-w-fit h-6",
                  disabled: !state.value.isEditMode
                }, null, 8, ["modelValue", "options", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createVNode(_unref(Dropdown), {
                  modelValue: match.value.matchType,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((match.value.matchType) = $event)),
                  options: matchType.value,
                  placeholder: "",
                  class: "text-center rounded-md border-2 shadow-none w-2/3 min-w-fit h-6",
                  disabled: !state.value.isEditMode
                }, null, 8, ["modelValue", "options", "disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("label", _hoisted_30, [
                _createTextVNode(" Ground: "),
                (!state.value.isValid && !match.value.venue.id)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, " Please fill in this field "))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_unref(Dropdown), {
                  modelValue: match.value.venue,
                  "onUpdate:modelValue": [
                    _cache[10] || (_cache[10] = ($event: any) => ((match.value.venue) = $event)),
                    _cache[11] || (_cache[11] = ($event: any) => (updateName()))
                  ],
                  options: ground.value,
                  filter: "",
                  optionLabel: "name",
                  placeholder: "Stadium Name",
                  class: "text-center rounded-md border-2 shadow-none w-full min-w-fit h-6",
                  disabled: !state.value.isEditMode
                }, null, 8, ["modelValue", "options", "disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createVNode(_unref(Dropdown), {
                  modelValue: match.value.toss,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((match.value.toss) = $event)),
                  options: tossWinnerOptions.value,
                  optionLabel: "name",
                  placeholder: "",
                  disabled: !state.value.isEditMode,
                  class: "text-center rounded-md border-2 shadow-none w-2/3 min-w-fit h-6 mr-1"
                }, null, 8, ["modelValue", "options", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(_unref(SelectButton), {
                    modelValue: match.value.tossDecision,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((match.value.tossDecision) = $event)),
                    options: tossDecisionOptions.value,
                    disabled: !state.value.isEditMode,
                    pt: { button: { class: ['py-0 px-2 bg-[#e5e7eb] border rounded-md m-0.5 w-[89px] text-sm'] }, },
                    class: "toss-decision bg-[#e5e7eb] rounded-md"
                  }, null, 8, ["modelValue", "options", "disabled"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", {
                  class: _normalizeClass(["flex md:flex-row flex-col items-center", !state.value.isValid && !match.value.team1.team.id ? 'pt-2' : ''])
                }, [
                  _createElementVNode("div", _hoisted_42, [
                    (!state.value.isValid && !match.value.team1.team.id)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_43, " Please select a team "))
                      : _createCommentVNode("", true),
                    _createVNode(_unref(Dropdown), {
                      modelValue: match.value.team1.team,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((match.value.team1.team) = $event)),
                      options: teams.value,
                      filter: "",
                      optionLabel: "name",
                      placeholder: "Team One",
                      onChange: _cache[15] || (_cache[15] = ($event: any) => {teamSelected(true); updateName()}),
                      class: "text-center rounded-md border-2 shadow-none w-full min-w-fit h-6",
                      disabled: !state.value.isEditMode
                    }, null, 8, ["modelValue", "options", "disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _hoisted_45,
                    _createVNode(_unref(Checkbox), {
                      modelValue: match.value.team1.homeTeam,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((match.value.team1.homeTeam) = $event)),
                      inputId: "homeTeam",
                      disabled: !state.value.isEditMode,
                      binary: true,
                      onChange: _cache[17] || (_cache[17] = ($event: any) => {if (match.value.team1.homeTeam) match.value.team2.homeTeam = false;})
                    }, null, 8, ["modelValue", "disabled"])
                  ])
                ], 2),
                _createVNode(_unref(PickList), {
                  modelValue: playersTeamOne.value,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((playersTeamOne).value = $event)),
                  dataKey: "id",
                  breakpoint: "800px",
                  class: _normalizeClass(["m-4", !state.value.isEditMode ? 'isDisabled' : '']),
                  "show-source-controls": false,
                  "show-target-controls": false,
                  "pt:movetotargetbutton:root:disabled": !state.value.isEditMode,
                  "pt:moveToSourceButton:root:disabled": !state.value.isEditMode,
                  "pt:moveAllToSourceButton:root:disabled": !state.value.isEditMode
                }, {
                  sourceheader: _withCtx(() => [
                    _hoisted_46
                  ]),
                  targetheader: _withCtx(() => [
                    _createElementVNode("span", _hoisted_47, [
                      _createTextVNode("Playing "),
                      (playersTeamOne.value[1])
                        ? (_openBlock(), _createElementBlock("span", _hoisted_48, ": " + _toDisplayString(playersTeamOne.value[1].length), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  item: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("span", _hoisted_50, _toDisplayString(slotProps.item.name), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "class", "pt:movetotargetbutton:root:disabled", "pt:moveToSourceButton:root:disabled", "pt:moveAllToSourceButton:root:disabled"]),
                _createElementVNode("div", _hoisted_51, [
                  _hoisted_52,
                  _createVNode(_unref(Dropdown), {
                    modelValue: teamOneCaptain.value,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((teamOneCaptain).value = $event)),
                    options: playersTeamOne.value[1],
                    filter: "",
                    optionLabel: "name",
                    placeholder: "",
                    class: "text-center rounded-md border-2 shadow-none w-2/3 min-w-fit h-6 mx-2",
                    disabled: !state.value.isEditMode
                  }, null, 8, ["modelValue", "options", "disabled"])
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _hoisted_54,
                  _createVNode(_unref(Dropdown), {
                    modelValue: teamOneViceCaptain.value,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((teamOneViceCaptain).value = $event)),
                    options: playersTeamOne.value[1],
                    filter: "",
                    optionLabel: "name",
                    placeholder: "",
                    class: "text-center rounded-md border-2 shadow-none w-2/3 min-w-fit h-6 mx-2",
                    disabled: !state.value.isEditMode
                  }, null, 8, ["modelValue", "options", "disabled"])
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _hoisted_56,
                  _createVNode(_unref(Dropdown), {
                    modelValue: teamOneKeeper.value,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((teamOneKeeper).value = $event)),
                    options: playersTeamOne.value[1],
                    filter: "",
                    optionLabel: "name",
                    placeholder: "",
                    class: "text-center rounded-md border-2 shadow-none w-2/3 min-w-fit h-6 mx-2",
                    disabled: !state.value.isEditMode
                  }, null, 8, ["modelValue", "options", "disabled"])
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("div", {
                  class: _normalizeClass(["flex md:flex-row flex-col items-center", !state.value.isValid && !match.value.team2.team.id ? 'pt-2' : ''])
                }, [
                  _createElementVNode("div", _hoisted_58, [
                    (!state.value.isValid && !match.value.team2.team.id)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_59, " Please select a team "))
                      : _createCommentVNode("", true),
                    _createVNode(_unref(Dropdown), {
                      modelValue: match.value.team2.team,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((match.value.team2.team) = $event)),
                      options: teams.value,
                      filter: "",
                      optionLabel: "name",
                      placeholder: "Team Two",
                      onChange: _cache[23] || (_cache[23] = ($event: any) => {teamSelected(false); updateName()}),
                      class: "text-center rounded-md border-2 shadow-none w-full min-w-fit h-6",
                      disabled: !state.value.isEditMode
                    }, null, 8, ["modelValue", "options", "disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_60, [
                    _hoisted_61,
                    _createVNode(_unref(Checkbox), {
                      modelValue: match.value.team2.homeTeam,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((match.value.team2.homeTeam) = $event)),
                      inputId: "homeTeam",
                      disabled: !state.value.isEditMode,
                      binary: true,
                      onChange: _cache[25] || (_cache[25] = ($event: any) => {if (match.value.team2.homeTeam) match.value.team1.homeTeam = false;})
                    }, null, 8, ["modelValue", "disabled"])
                  ])
                ], 2),
                _createVNode(_unref(PickList), {
                  modelValue: playersTeamTwo.value,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((playersTeamTwo).value = $event)),
                  dataKey: "id",
                  breakpoint: "800px",
                  class: _normalizeClass(["m-4", !state.value.isEditMode ? 'isDisabled' : '']),
                  "show-source-controls": false,
                  "show-target-controls": false,
                  "pt:movetotargetbutton:root:disabled": !state.value.isEditMode,
                  "pt:moveToSourceButton:root:disabled": !state.value.isEditMode,
                  "pt:moveAllToSourceButton:root:disabled": !state.value.isEditMode
                }, {
                  sourceheader: _withCtx(() => [
                    _hoisted_62
                  ]),
                  targetheader: _withCtx(() => [
                    _createElementVNode("span", _hoisted_63, [
                      _createTextVNode("Playing "),
                      (playersTeamTwo.value[1])
                        ? (_openBlock(), _createElementBlock("span", _hoisted_64, ": " + _toDisplayString(playersTeamTwo.value[1].length), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  item: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("span", _hoisted_66, _toDisplayString(slotProps.item.name), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "class", "pt:movetotargetbutton:root:disabled", "pt:moveToSourceButton:root:disabled", "pt:moveAllToSourceButton:root:disabled"]),
                _createElementVNode("div", _hoisted_67, [
                  _hoisted_68,
                  _createVNode(_unref(Dropdown), {
                    modelValue: teamTwoCaptain.value,
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((teamTwoCaptain).value = $event)),
                    options: playersTeamTwo.value[1],
                    filter: "",
                    optionLabel: "name",
                    placeholder: "",
                    class: "text-center rounded-md border-2 shadow-none w-2/3 min-w-fit h-6 mx-2",
                    disabled: !state.value.isEditMode
                  }, null, 8, ["modelValue", "options", "disabled"])
                ]),
                _createElementVNode("div", _hoisted_69, [
                  _hoisted_70,
                  _createVNode(_unref(Dropdown), {
                    modelValue: teamTwoViceCaptain.value,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((teamTwoViceCaptain).value = $event)),
                    options: playersTeamTwo.value[1],
                    filter: "",
                    optionLabel: "name",
                    placeholder: "",
                    class: "text-center rounded-md border-2 shadow-none w-2/3 min-w-fit h-6 mx-2",
                    disabled: !state.value.isEditMode
                  }, null, 8, ["modelValue", "options", "disabled"])
                ]),
                _createElementVNode("div", _hoisted_71, [
                  _hoisted_72,
                  _createVNode(_unref(Dropdown), {
                    modelValue: teamTwoKeeper.value,
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((teamTwoKeeper).value = $event)),
                    options: playersTeamTwo.value[1],
                    filter: "",
                    optionLabel: "name",
                    placeholder: "",
                    class: "text-center rounded-md border-2 shadow-none w-2/3 min-w-fit h-6 mx-2",
                    disabled: !state.value.isEditMode
                  }, null, 8, ["modelValue", "options", "disabled"])
                ])
              ]),
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("label", _hoisted_76, [
                      _createTextVNode("Match Referee: "),
                      (!state.value.isValid && !match.value.umpires.matchReferee.id)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_77, " Please fill in this field "))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_unref(Dropdown), {
                      modelValue: match.value.umpires.matchReferee,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((match.value.umpires.matchReferee) = $event)),
                      class: "rounded-md border-2 shadow-none h-6 w-1/2 text-center self-center",
                      placeholder: "",
                      options: umpires.value,
                      filter: "",
                      optionLabel: "name",
                      disabled: !state.value.isEditMode
                    }, null, 8, ["modelValue", "options", "disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("label", _hoisted_79, [
                      _createTextVNode("Match Umpires: "),
                      (!state.value.isValid && match.value.umpires.matchUmpires.length == 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_80, " Please fill in this field "))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_unref(MultiSelect), {
                      modelValue: match.value.umpires.matchUmpires,
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((match.value.umpires.matchUmpires) = $event)),
                      showToggleAll: false,
                      class: "rounded-md border-2 shadow-none h-6 w-1/2 text-center self-center",
                      placeholder: "",
                      options: umpires.value,
                      filter: "",
                      optionLabel: "name",
                      disabled: !state.value.isEditMode,
                      pt: { label: { class: ['p-0 pl-1'] } }
                    }, null, 8, ["modelValue", "options", "disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("label", _hoisted_82, [
                      _createTextVNode("TV Umpire: "),
                      (!state.value.isValid && !match.value.umpires.tvUmpire.id)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_83, " Please fill in this field "))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_unref(Dropdown), {
                      modelValue: match.value.umpires.tvUmpire,
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((match.value.umpires.tvUmpire) = $event)),
                      class: "rounded-md border-2 shadow-none h-6 w-1/2 text-center self-center",
                      placeholder: "",
                      options: umpires.value,
                      filter: "",
                      optionLabel: "name",
                      disabled: !state.value.isEditMode
                    }, null, 8, ["modelValue", "options", "disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_84, [
                    _createElementVNode("label", _hoisted_85, [
                      _createTextVNode("Reserve Umpire: "),
                      (!state.value.isValid && !match.value.umpires.reserveUmpire.id)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_86, " Please fill in this field "))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_unref(Dropdown), {
                      modelValue: match.value.umpires.reserveUmpire,
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((match.value.umpires.reserveUmpire) = $event)),
                      class: "rounded-md border-2 shadow-none h-6 w-1/2 text-center self-center",
                      placeholder: "",
                      options: umpires.value,
                      filter: "",
                      optionLabel: "name",
                      disabled: !state.value.isEditMode
                    }, null, 8, ["modelValue", "options", "disabled"])
                  ])
                ])
              ])
            ])
          ])
        ]),
        (state.value.isEditMode)
          ? (_openBlock(), _createElementBlock("footer", _hoisted_87, [
              _createElementVNode("button", {
                class: "border-2 border-[#1f2937] hover:bg-gray-200 text-[#1f2937] font-semibold my-1.5 h-6 pt-0 pb-[1px] px-6 rounded mr-1 items-center flex",
                onClick: _cache[34] || (_cache[34] = ($event: any) => (confirmCancel()))
              }, " Cancel "),
              _createElementVNode("button", {
                class: "bg-[#1f2937] hover:bg-slate-500 text-white font-semi my-1.5 h-6 pt-0 pb-[1px] px-6 rounded items-center flex",
                onClick: _cache[35] || (_cache[35] = ($event: any) => (confirmSave())),
                disabled: !state.value.isEditMode
              }, " Save ", 8, _hoisted_88)
            ]))
          : (_openBlock(), _createElementBlock("footer", _hoisted_89, [
              _createElementVNode("button", {
                class: "bg-[#1f2937] hover:bg-slate-500 text-white font-semi my-1.5 h-6 pt-0 pb-[1px] px-6 rounded mr-1 items-center flex",
                onClick: _cache[36] || (_cache[36] = ($event: any) => {state.value.isEditMode = true; _ctx.$emit('changeMatchEditState', true)})
              }, " Edit Match ")
            ]))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_90, [
        _createVNode(_unref(ProgressSpinner), {
          class: "w-90 h-90 mb-2",
          "attrs-color-black": "",
          strokeWidth: "5",
          animationDuration: "1s",
          "aria-label": "Loading"
        })
      ]))
}
}

})